<!-- <p-toast></p-toast> -->
<div class="row">
  <div class="col-12 text-center">
    <b><h4>La bonne personne au bon moment</h4></b>
  </div>
</div>

<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <section class="first-part">
    <div class="row mt-2">
      <div class="col-12">
        <p-divider>
          <b>Qui êtes-vous ?</b>
        </p-divider>
      </div>
    </div>
    
    <div class="row mt-1">
      <div class="col-12">
        <span class="p-float-label">
          <p-dropdown
            [options]="types"
            [(ngModel)]="selectedType"
            [ngModelOptions]="{standalone: true}"
            optionLabel="description"
            class="p-inputtext-sm col-12"
          ></p-dropdown>
        </span>
      </div>
    </div>
  
    <div class="row mt-2">
      <div class="col-12">
        <p-divider>
          <b>Vos informations</b>
        </p-divider>
      </div>
    </div>
  
    <div class="row mt-1">
      <div class="col-12 col-md-3">
        <span class="col-12 p-float-label">
          <p-dropdown
            formControlName="genre"
            [options]="genres"
            optionLabel="description"
            class="p-inputtext-sm col-12"
          ></p-dropdown>
        </span>
      </div>
  
      <div class="col-12 col-md-4">
        <span class="p-float-label">
          <input
            type="text"
            id="nom"
            pInputText
            formControlName="nom"
            class="p-inputtext-sm col-12"
          />
          <label for="nom">Nom <span style="color: red;">*</span></label>
        </span>
        <div *ngIf="formSubmitted && demandeCheckForm.nom.errors" class="invalid-feedback">
          <div *ngIf="demandeCheckForm.nom.errors.required">Obligatoire</div>
        </div>
      </div>
  
      <div class="col-12 col-md-5">
        <span class="p-float-label">
          <input
            type="text"
            id="prenom"
            pInputText
            formControlName="prenom"
            class="p-inputtext-sm col-12"
          />
          <label for="prenom">Prénom(s) <span style="color: red;">*</span></label>
        </span>
        <div *ngIf="formSubmitted && demandeCheckForm.prenom.errors" class="invalid-feedback">
          <div *ngIf="demandeCheckForm.prenom.errors.required">Obligatoire</div>
        </div>
      </div>
    </div>
  
    <div class="row justify-content-center mt-5">
      <div class="col-12 col-md-4">
        <span class="p-float-label">
          <p-calendar
            id="dateNaissance"
            formControlName="dateNaissance"
            class="p-inputtext-sm col-12"
          ></p-calendar>
          <label>Date de naissance <span style="color: red;">*</span></label>
        </span>
      </div>
  
      <div class="col-12 col-md-4">
        <span class="p-float-label">
          <input
            type="tel"
            id="telephone"
            pInputText
            formControlName="telephone"
            class="p-inputtext-sm col-12"
          />
          <label for="telephone">Téléphone <span style="color: red;">*</span></label>
        </span>
        <div *ngIf="formSubmitted && demandeCheckForm.telephone.errors" class="invalid-feedback">
          <div *ngIf="demandeCheckForm.telephone.errors.required">Obligatoire</div>
        </div>
      </div>
  
      <div class="col-12 col-md-4">
        <span class="p-float-label">
          <input
            type="email"
            id="email"
            pInputText
            formControlName="email"
            class="p-inputtext-sm col-12"
          />
          <label for="email">Email <span style="color: red;">*</span></label>
        </span>
        <div *ngIf="formSubmitted && demandeCheckForm.email.errors" class="invalid-feedback">
          <div *ngIf="demandeCheckForm.email.errors.required">Obligatoire</div>
        </div>
      </div>
    </div>
  
    <div class="row justify-content-center mt-4">
      <!-- <div class="col-12 col-md-4">
        <p-dropdown class="p-inputtext-sm col-12" [options]="countries" formControlName="nationalite" optionLabel="name.common" [showClear]="true" placeholder="Naltionalité">
          <ng-template pTemplate="countrySelected">
              <div class="flex align-items-center gap-2" *ngIf="countrySelected">
                <img [src]="countrySelected.flags.png"  width="22" height="18" [class]="'flag flag-' + countrySelected.name.common.toLowerCase()"/> {{ countrySelected.name.common }}
              </div>
          </ng-template>
          <ng-template let-country pTemplate="item">
              <div class="flex align-items-center gap-2">
                <img [src]="country.flags.png"  width="22" height="18" [class]="'flag flag-' + country.name.common.toLowerCase()"/> {{ country.name.common }}
              </div>
          </ng-template>
        </p-dropdown>
      </div> -->
  
      <div class="col-12">
        <span class="p-float-label">
          <input
            type="text"
            id="adresse"
            pInputText
            formControlName="adresse"
            class="p-inputtext-sm col-12"
          />
          <label for="adresse">Adresse de résidence</label>
        </span>
      </div>
    </div>
  </section>

  <div class="row mt-2">
    <div class="col-12">
      <p-divider>
        <b>Informations sur votre demande</b>
      </p-divider>
    </div>
  </div>

  <section class="second-part">
    <div class="row">
      <div class="col-12">
        <div class="row">
          <div *ngFor="let item of demandes" class="col-12 col-md-6 col-lg-4 col-xl-3">
            <span class="p-input-icon-right"
              [pTooltip]="item.matiere.libelle+' '+item.niveauDomaineEtude.niveauEtude.code+' '+ item.niveauDomaineEtude.domaineEtude?.code+'\n'+item.motif"
              tooltipPosition="top"
            >
              <input pInputText type="text" [disabled]="true" class="p-inputtext-sm item-demande" [value]="item.matiere.libelle+' '+item.niveauDomaineEtude.niveauEtude.code+' '+ item.niveauDomaineEtude.domaineEtude?.code" />
              <i class="pi pi-trash del-demande"></i>
            </span>
          </div>
          <!-- <div class="col-12 col-md-6 col-lg-4 col-xl-3">
            <span class="p-input-icon-right" pTooltip="Enter your username" tooltipPosition="top">
              <input pInputText type="text" [disabled]="true" class="p-inputtext-sm item-demande" value="Mathématique Tle C" />
              <i class="pi pi-trash del-demande"></i>
            </span>
          </div>demandes -->
          <!-- <div class="col-12 col-md-6 col-lg-4 col-xl-3">
            <span class="p-input-icon-right" pTooltip="Enter your username" tooltipPosition="top">
              <input pInputText type="text" [disabled]="true" class="p-inputtext-sm item-demande" value="PCT Tle D" />
              <i class="pi pi-trash del-demande"></i>
            </span>
          </div> -->
          <div *ngIf="!addClasse" class="col-12 col-md-6 col-lg-4 col-xl-3">
            <p-button label="Ajouter" (click)="showAddBox()" styleClass="p-button-raised p-button-text p-button-success"></p-button>
          </div>
        </div>
      </div>
      <div *ngIf="addClasse" class="col-12 mt-4 addBox">
        <div class="row">
          <div class="col-12 col-md-4">
            <span class="col-12 p-float-label">
              <p-dropdown class="p-inputtext-sm col-12" [options]="matieres" [(ngModel)]="matiereSelected"
                [ngModelOptions]="{standalone: true}" optionLabel="libelle" [showClear]="false">
                <ng-template pTemplate="matiereSelected">
                    <div class="flex align-items-center gap-2" *ngIf="matiereSelected">
                       {{ matiereSelected.libelle }}
                    </div>
                </ng-template>
                <ng-template let-mat pTemplate="item">
                    <div class="flex align-items-center gap-2">
                        {{ mat.libelle }}
                    </div>
                </ng-template>
              </p-dropdown>
              <label for="prenom">Matière <span style="color: red;">*</span></label>
              <!-- <p-dropdown
                [options]="matieres"
                [(ngModel)]="matiereSelected"
                [ngModelOptions]="{standalone: true}"
                optionLabel="libelle"
                class="p-inputtext-sm col-12"
              ></p-dropdown> -->
            </span>
          </div>
          <div class="col-12 col-md-8">
            <span class="col-12 p-float-label">
              <p-dropdown class="p-inputtext-sm col-12" [options]="niveauxDomaines" [(ngModel)]="niveauDomaineMultiSelected"
                [ngModelOptions]="{standalone: true}" optionLabel="niveauEtude.code" [showClear]="false">
                <ng-template let-kk>
                    <div class="flex align-items-center gap-2" *ngIf="niveauDomaineMultiSelected">
                      {{ kk.niveauEtude.code }} - {{ kk.domaineEtude?.code }}
                    </div>
                </ng-template>
                <ng-template let-class pTemplate="item">
                    <div class="flex align-items-center gap-2">
                      {{ class.niveauEtude.code }} - {{ class.domaineEtude?.code }}
                    </div>
                </ng-template>
              </p-dropdown>
              <label for="prenom">Classe <span style="color: red;">*</span></label>
              <!-- <p-dropdown
                [options]="niveauxDomaines"
                [(ngModel)]="niveauDomaineMultiSelected"
                [ngModelOptions]="{standalone: true}"
                optionLabel="niveauEtude.code,domaineEtude.code"
                class="p-inputtext-sm col-12"
              ></p-dropdown> -->
            </span>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-12">
            <textarea pInputTextarea [(ngModel)]="motif"
            [ngModelOptions]="{standalone: true}" placeholder="Motif" rows="4"></textarea>
            <!-- <p-editor formControlName="motif" [(ngModel)]="motif" [style]="{ height: '320px' }"></p-editor> -->
            <!--  cols="30" -->
            <!-- <p-editor formControlName="motif" [(ngModel)]="motif" [style]="{ height: '320px' }">
              <ng-template pTemplate="header">
                  <span class="ql-formats">
                      <button type="button" class="ql-bold" aria-label="Bold"></button>
                      <button type="button" class="ql-italic" aria-label="Italic"></button>
                      <button type="button" class="ql-underline" aria-label="Underline"></button>
                  </span>
              </ng-template>
            </p-editor> -->
          </div>
          <div class="col-12">
            <p-button label="Valider" (click)="saveAddBox()" styleClass="p-button-raised p-button-text p-button-primary"></p-button>
            <p-button label="Annuler" (click)="closeAddBox()" styleClass="p-button-raised p-button-text p-button-secondary"></p-button>
          </div>
        </div>
      </div>
  
    </div>
  </section>

  <div class="row mt-3 justify-content-center">
    <div class="col-12">
      <p-messages [(value)]="messages" [enableService]="false" [closable]="true"></p-messages>
    </div>
    <div class="col-12 col-md-6 btn">
      <button type="submit">Envoyer</button>
    </div>
  </div>


</form>